import { Component, ChangeDetectionStrategy, inject, input, output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { CredentialsService } from '@core/utils';

import { Menu } from '@data/models';

@Component({
  selector: 'app-sidebar, [app-sidebar]',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  private readonly router = inject(Router);
  private readonly credentialsService = inject(CredentialsService);

  isSidebarOpen = input.required<boolean>();
  isCollapsed = true;
  handleToggle = output<boolean>();

  readonly menu = input.required<Menu[]>();

  codigo = this.credentialsService.credentials()?.rolCodigo;

  changeSidebarStatus(isFromTemplate?: boolean) {
    if (!isFromTemplate || (isFromTemplate && window.innerWidth < 1536)) {
      this.handleToggle.emit(!this.isSidebarOpen());
    }

    const allMenuItems = document.querySelectorAll('.c-nav__item.show');

    allMenuItems.forEach(item => {
      item.classList.remove('show');
    });
  }

  collapseNavItem(event: HTMLLIElement) {
    const children: HTMLCollection = event.parentElement?.children as HTMLCollection;
    this.isCollapsed = !this.isCollapsed;

    for (const child of Array.from(children)) {
      if (child.ariaLabel !== event.ariaLabel && child.classList.contains('show')) {
        child.classList.remove('show');
      }
    }

    if (event.classList.contains('show')) {
      event.classList.remove('show');
    } else {
      event.classList.add('show');
    }
  }

  logout() {
    this.credentialsService.setCredentials();
    this.credentialsService.setUsuario();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
